export const APP_VERSION = "2026.07.27";
export default APP_VERSION;
